module.exports = __webpack_public_path__ + "img/whapwhite.11d66ac9.svg";